/**
 * Admin utility functions.
 */

/**
 * Check if a user object represents an admin user.
 * @param user - User object from auth context
 * @returns true if user is an admin, false otherwise
 */
export function isAdminUser(user: unknown): boolean {
  // Check if user has admin user_group
  if (!user || typeof user !== 'object') {
    return false;
  }

  // Check if user has user_group and it's named "admin"
  const userGroup = (user as { user_group?: { name?: string } }).user_group;
  return userGroup?.name?.toLowerCase() === 'admin';
}
